var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout"},[_c('router-link',{attrs:{"to":{ name: 'Home' }},on:{"click":_vm.closeAboutContentFullDetail}},[(this.$route.name !== 'Events')?_c('ImgSVG',{staticClass:"img logo",attrs:{"src":_vm.ucallLogo,"alt":"ucall logo"}}):_vm._e()],1),_c('app-menu'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }